export class Constants {
    public static STUDENT = 1;
    public static UNIVERSITY = 2;
    public static ACTIONS = 3;
    public static TERM_SETTINGS = 4;
    public static STUDENT_HOME = 5;
    public static PROGRAMMES = 6;
    public static ROUND_SETTINGS = 7;
    public static ADD_TERM_SETTINGS = 8;
    public static UPDATE_ROUND_SETTINGS = 9;
    public static EDIT_TERM_SETTINGS = 10;
    public static BIDDING_RESPONSE = 11;
    public static GENERATE_RANKS = 12;
    public static GENERATE_RESULTS = 13;
    public static CLEAR_ALL = 14;
    public static OIA_HOME = 15;
    public static ROUND2_DATA = 16;
    public static STUDENT_GIVEN_AND_NOT_GIVEN_PREFERENCES = 17;
    public static MODIFY_ROUND2_UNIVERSITY = 18;
    public static PROCESSING_OUTPUT = 19;
    public static STUDENT_REGISTRATION = 20;
    public static EDIT_UNIVERSITY = 21;
    public static STUDENT_RANK = 22;
    public static STUDENT_REGISTRATION_STATUS = 23;
    public static DELETE_EXPERIENCE = 24;
    public static REGISTERED_STUDENTS = 25;
    public static GET_REGISTERED_STUDENT_DETAILS = 26;
    public static EDIT_REGISTERED_STUDENT = 27;
    public static DELETE_POC = 28;
    public static GENERATE_PREFERENCES = 29;
    public static CLEAR_RANKS = 30;
    public static CLEAR_RESULTS = 31;
    public static PRACTICE_ROUND_UNIVERSITY_PREFERENCES = 32;
    public static UNIVERSITY_PREFERENCES = 33;
    public static PRACTICE_ROUND_UNIVERSITY_WISE_ALLOTMENT = 34;
    public static UNIVERSITY_WISE_ALLOTMENT = 35;
    public static ROUND_TWO_ALLOTMENT = 36;
    public static FINAL_UNIVERSITY_ALLOTMENT = 37;
    public static FINAL_UNIVERSITY_WISE_ALLOTMENT = 38;
    public static GET_DOCUMENT_PAGE_DATE = 39;
    public static DOWNLOAD_DOCUMENT = 40;
    public static GET_UNIVERSITY_WISE_STUDENT_LIST = 41;
    public static DIVERSITY_REPORT = 42;
    public static BALANCE_OF_TRADE_REPORT = 43;
    public static VALIDATE_ALL_REGISTRATIONS = 44;
    public static FEEDBACK = 45;
    public static ACADEMIC_YEAR = 46;
    public static FINAL_STUDENT_REGISTRATION = 47;
    public static SEND_ROUND_RESULT = 48;


    public static NOMINATIONS = 49;
    public static ADD_NOMINATION = 50;
    public static EDIT_NOMINATION = 51;
    public static CHANGE_STUDENT_STATE = 52;
    public static  INCOMING_TERM_SETTINGS = 53;
    public static ADD_INCOMING_TERM_SETTINGS = 54;
    public static EDIT_INCOMING_TERM_SETTINGS = 55;
    public static INCOMING_STUDENT_HOME_DETAILS = 56;
    public static POC_HOME_DETAILS = 57;
    public static INCOMING_STUDENT_REGISTRATION = 58;
    public static INCOMING_STUDENT_FILE_DELETE = 60;
    public static FINAL_INCOMING_STUDENT_REGISTRATION = 61;
    public static SEND_NOMINATION_EMAIL = 62;
    public static DELETE_INCOMING_TERM_SETTINGS = 63;
    public static INCOMING_REGISTRATIONS = 64;
    public static ACCEPT_NOMINATION = 65;
    public static REJECT_NOMINATION = 66;
    public static PAST_DATA = 67;
    public static OUTGOING_STUDENT_FILE_DELETE = 68;
    public static BIDDING_RESPONSE_REPORT = 69;
    public static PROCESSING_OUTPUT_REPORT = 70;

    public static CHANGE_DREAM_UNIVERSITY = 71;
    public static CONFIRM_UNIVERSITY = 72;
    public static UN_CONFIRM_UNIVERSITY = 73;
    public static OPT_OUT_FROM_EXCHANGE = 74;
    public static SELECT_PREVIOUS_ROUND_PREFERENCES = 75;
    public static DELETE_ROUND = 76;
    public static FINAL_OPTED_OUT_STUDENTS = 77;
    public static LOGIN_DETAILS_TO_POC = 78;
    public static INCOMING_POC = 79;
    public static LOGIN_DETAILS_TO_POC_BY_POC_ID = 80;
    public static GET_INCOMING_STUDENT_DOCUMENT_DATA = 81;

    public static OUTGOING_BATCH = 82;
    public static ROUNDS_FILTER = 83;
    public static IIMB_EMAILS = 84;
    public static DOWN_INCOM_STU_DOC = 85;

    public static ACCESS_ROUND = 'access';
    public static ACCESS_HOME = 'ACCESS_HOME';
    public static ROUND_CRON = 'ROUND_CRON';

    public static NO_STATUS = 0;
    public static PENDING = 1;
    public static ACCEPTED = 2;
    public static REJECTED = 3;
    public static INCOMING_STUDENT_NOMINATED = 1;
    public static INCOMING_STUDENT_REGISTERED = 2;
    public static INCOMING_STUDENT_WITHDRAWN = 3;
    public static INCOMING_STUDENT_ACCEPTED = 4;
    public static INCOMING_STUDENT_REJECTED = 5;

    public static OIA_USER_ID = 1;
    public static OUTGOING_STUDENT = 'OUTGOING_STUDENT';
    public static INCOMING_STUDENT = 'INCOMING_STUDENT';
    public static EC = 'EC';
    public static OIA = 'OIA';
    public static POC = 'POC';


    public static PROGRAMME_PGP_CODE = 11;


    public static FACTSHEET = 6;
    public static MOU = 7;
    public static VISA_ATTACHMENT = 8;
    public static LATEST_TRANSCRIPT_ATTACHMENT = 9;
    public static PASSPORT_ATTACHMENT = 10;
    public static PHOTO_ATTACHMENT = 11;
    public static RESUME_ATTACHMENT = 12;
    public static HOSTEL_CODE_OF_CONDUCT_ATTACHMENT = 13;
    public static RELEASE_CUM_IDENTITY_BOND_ATTACHMENT = 14;
    public static HEALTH_CERTIFICATE_ATTACHMENT = 16;

    public static UNIVERSITIES_BY_OUTGOING_ROUND_ID = 86;
    public static STUDENTS_BY_OUTGOING_ROUND_ID = 87;
    public static ADD_STUDENT_TO_BIDDING_RESULTS = 88;

    public static GET_INCOMING_TERM_VISA_SETTINGS = 89;
    public static ADD_INCOMING_TERM_VISA_SETTINGS = 90;
    public static EDIT_INCOMING_TERM_VISA_SETTINGS = 91;
    public static GET_ALL_ACADEMIC_YEARS = 92;
    public static UPDATE_INCOMING_TERM_VISA_SETTING = 93;
    public static  ADD_INCOMING_TERM_VISA_SETTING = 94; 
    public static GET_INCOMING_TERM_VISA_SETTINGS_BY_ID = 95;
    public static  GET_INCOMING_TERM_SETTINGS_FOR_VISA = 96;
    public static INCOMING_STUDENT_REGISTRATION_BY_TERM_ID = 97;
    public static DREAM_UNIVERSITY_PREFERNCES = 98;



}
